import classNames from 'classnames';
import DOMPurify from 'dompurify';
import { Marked } from 'marked';
import React from 'react';

interface PlainMarkdownText extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  accentColor?: string;
}

export default function PlainMarkdownText({
  text,
  accentColor = 'yellow',
  className
}: PlainMarkdownText) {
  const marked = new Marked();
  const renderer = new marked.Renderer();

  renderer.link = function (href: string, title: string, text: string): string {
    return `<a style="color: ${accentColor}" href="${href}" title="${title}" target="_blank">${text}</a>`;
  };

  renderer.list = function (body: string, ordered: boolean): string {
    const listType = ordered ? 'list-decimal' : 'list-disc';
    return `<ul class="${listType} pl-md py-sm">${body}</ul>`;
  };

  renderer.listitem = function (text: string): string {
    return `<li class="mb-xs">${text}</li>`;
  };

  renderer.blockquote = function (quote: string): string {
    return `<blockquote class="border-l-2 border-gray-300 pl-md py-sm my-sm">${quote}</blockquote>`;
  };

  renderer.strong = function (text: string): string {
    return `<strong class="font-bold">${text}</strong>`;
  };

  renderer.em = function (text: string): string {
    return `<em class="italic">${text}</em>`;
  };

  renderer.paragraph = function (text: string): string {
    return `<p class="mb-md">${text}</p>`;
  };

  marked.use({
    pedantic: false,
    gfm: true,
    breaks: true,
    renderer: renderer
  });

  const parsedHtml = marked.parse(text || '') as string;
  const sanitizedHtml = DOMPurify.sanitize(parsedHtml);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      className={classNames('select-text', className)}
    />
  );
}
